export default "__VITE_ASSET__Jxhxs5ek__"